module.exports = __webpack_public_path__ + "static/media/faucet-drip.0f5b72de.svg";